export default __webpack_public_path__ + "static/media/maintenance.45c70601.png";